var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",attrs:{"items":_vm.itemPlaces,"item-text":"name","item-value":"id","menu-props":"auto","placeholder":"Wszystkie miasta","single-line":"","multiple":"","chips":"","deletable-chips":""},model:{value:(_vm.placeSelected),callback:function ($$v) {_vm.placeSelected=$$v},expression:"placeSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }